import React, { Component } from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import asyncValidate from "./asyncValidate";
import FormFieldsTabAddress from "../../form-fields/tab-address/tab-address";
class EditViewPostDischargeTabAddress extends Component {
  render() {
    return (
      <div>
        <FormFieldsTabAddress {...this.props} locked={this.props.locked} />
      </div>
    );
  }
}
EditViewPostDischargeTabAddress.propTypes = {
  locked: PropTypes.bool,
};
EditViewPostDischargeTabAddress = reduxForm({
  form: "PostDischargeEditForm", // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(EditViewPostDischargeTabAddress);
export default EditViewPostDischargeTabAddress;
